import {useRef} from 'react';
import {usePixelOverflow} from './usePixelOverflow';

export const useProductSnippetLayout = () => {
    const mainRef = useRef<HTMLDivElement>(null);
    const mainInnerRef = useRef<HTMLDivElement>(null);
    const {pixelOverflow} = usePixelOverflow({mainRef, mainInnerRef});

    return {
        mainRef,
        mainInnerRef,
        pixelOverflow,
    };
};
